// extracted by mini-css-extract-plugin
export default {"edit_btn":"WorkQDeferredCustomSelect_edit_btn__U6sIb","shell_inner":"WorkQDeferredCustomSelect_shell_inner__0rWPY","shell_selected":"WorkQDeferredCustomSelect_shell_selected__b+Rbr"};